import toast from '../vuecomps/Toast.vue'
export default (Vue) => {
    let toastComp = Vue.extend(toast);
    function showToast(msg, duration = 3000,richText='',successIcon=false) {
        let toastDom = new toastComp({
            data() {
                return {
                    show: true,
                    msg,
                    richText,
                    successIcon
                }
            }
        }).$mount()

        document.body.appendChild(toastDom.$el);
        setTimeout(() => {
            toastDom.show = false
        }, duration)
    }
    Vue.prototype.$toast = showToast;
}